export interface CertificationItem {
  id: string;
  name: string;
  imagePath: string;
}

export const certificationsData: CertificationItem[] = [
  {
    id: "iso-9001-2015",
    name: "ISO 9001:2015",
    imagePath: "/certifications/cer1.webp",
  },
  {
    id: "udyam",
    name: "Udyam Registration",
    imagePath: "/certifications/cer2.webp",
  },
  {
    id: "gst",
    name: "GST Registered",
    imagePath: "/certifications/cer3.webp",
  },
  {
    id: "iec",
    name: "Import Export Code (IEC)",
    imagePath: "/certifications/cer4.webp",
  },
  {
    id: "epch",
    name: "EPCH Member",
    imagePath: "/certifications/cer5.webp",
  },
];